import { Component, Input, OnInit } from '@angular/core';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

import { SearchActivityEvents } from 'generated/graphql';

@Component({
  selector: 'app-response-event',
  templateUrl: './response-event.component.html'
})

export class ASResponseEventComponent extends WithDisposableSubject() implements OnInit {

  @Input() item: SearchActivityEvents.Node;

  categoryName: string;
  responseName: string;
  payload: any;
  /**
   *
   */
  constructor(
  ) {
    super();
  }

  ngOnInit() {
    this.payload = this._getPayload();
    this.responseName = this.payload?.tag?.name;
    this.categoryName = this.payload?.category?.name;
  }

  private _getPayload() {
    return this.item.payload?.taggableLogbook;
  }

}
